export default __webpack_public_path__ + "static/media/tmdb_logo.e34f1a22.svg";